<app-jurormenu></app-jurormenu>
<div class="row">
    <h2>Accepted Entries</h2>
    <div>
        <ul *ngFor="let entry of entries" style="width: 40%">
        <li *ngIf="entry.jurorSelection > 0 && entry.jurorSelection <= 2">
            <div [class.dimmed]="entry.jurorSelection === 3">
                {{ entry.submissionID }}
                <button type="button" class="btn btn-secondary btn-block btn-danger"
                    (click)='reject(entry.submissionID)'>Reject</button>
                <div class="row border m3">
                    <app-showimg [showDesc]='false' class="col" *ngIf="entry.jurorSelection === 1" [entryImage]='entry.entryImage1'></app-showimg>
                    <app-showimg [showDesc]='false' class="col" *ngIf="entry.jurorSelection === 2" [entryImage]='entry.entryImage2'></app-showimg>
                </div>
            </div>
        </li>
        </ul>
    </div>
</div>
